module.exports = __webpack_public_path__ + "static/img/weitu-2.4dcb077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weitu-2.png
// module id = f+Wi
// module chunks = 0